export const getError = state => state.editInactivity.get('error')
export const getIsSubmitting = state => state.editInactivity.get('isSubmitting')
